module.exports = __webpack_public_path__ + "img/4263.fe778bba.jpg";